// BASIC STARTER REQUIREMENTS
var lazy = require('./vendor/jquery.lazy.js')
require('./vendor/skip-link-focus-fix.js')
require('babel-polyfill')

// ADDITIONAL 3RD PARTY REQUIREMENTS
var slick 		    	= require('./vendor/slick.js');
// var _ 				= require('underscore');
// var moment 			= require('moment');
// var foundation 		= require('foundation-sites'); // Requires: npm install foundation-sites

// Get Viewport Dimensions
function updateViewportDimensions() {
    var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
    return { width:x,height:y };
}

function isInternetExplorer () {
    return !!( navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/) );
}

// setting the viewport width
var viewport = updateViewportDimensions();

// David Walsh Debounce
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    }
}

// Throttle from underscore 1.8.3
function throttle (func, wait, options) {
    var context, args, result
    var timeout = null
    var previous = 0
    if (!options) options = {}
    var later = function () {
        previous = options.leading === false ? 0 : Date.now()
        timeout = null
        result = func.apply(context, args)
        if (!timeout) context = args = null
    }
    return function () {
        var now = Date.now()
        if (!previous && options.leading === false) previous = now
        var remaining = wait - (now - previous)
        context = this
        args = arguments
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            previous = now
            result = func.apply(context, args)
            if (!timeout) context = args = null
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining)
        }
        return result
    }
}

// Braid Namespace
var braid = braid || {};

// utilities
braid.query = function(selector) {
    return document.querySelector(selector);
};

braid.isHome = !!document.getElementsByClassName('home').length;
braid.isFlexible = !!document.getElementsByClassName('page-template-page-flexible').length;
braid.hasForm = !!document.getElementsByClassName('gform_wrapper').length;
braid.header = document.getElementById("masthead");
braid.content = document.getElementById("content");
braid.menu = document.getElementById("mobile-navigation-wrapper");
braid.page = document.getElementById("page");
braid.mobileBreakpoint = 680;



// Set up namespace
var braidStarter = braidStarter || {};

(function(ns, $win, $, undefined) {
    var $htmlBody = $('html, body');

    // http://jquery.eisbehr.de/lazy/
    // usage <img class="lazy" data-src="/some-path" alt=""> for img
    // usage <div class="lazy" data-src="/some-path" alt=""> for background image
    function initLazyLoad() {
        $('.lazy').lazy({
            effect: "fadeIn",
            effectTime: 500,
            threshold: 500
        });
    }

    function toggleNavMenu() {
        $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function() {
            $(this).toggleClass('open');
            var $menu = $(braid.menu);
            $menu.slideToggle();
            $menu.toggleClass('active');
        });
    }

    function smoothScroll() {
        var $links = $('.smooth-scroll');

        $links.click(function(e){
            e.preventDefault();
            var $this = $(this);
            var $target = $($this.attr('href'));
            $htmlBody.animate({scrollTop: $target.offset().top}, '500', 'swing');
        });
    }

    function contentAccordion() {
        $('.content-accordion').on('click', '.content-accordion--btn', function() {
            var $btn = $(this);
            var $container = $btn.closest('.content-accordion');
            var $content = $container.find('.content-accordion--hidden');
            $content.slideToggle(function(){
                $content.is(':visible') ? $btn.text('See Less') : $btn.text('See More');;
            });
        });
    }

    function handleLoginMenuToggle() {
        var $loginMenu = $('.js-login-button');
        var $loginMenuButton = $loginMenu.children('a');
        $loginMenuButton.click(function() {
            $loginMenu.toggleClass('active');
        });
    }

    function initSlider () {
        var $images = $('.js-images');

        if($images.length) {
            var scrollWidth = $images.get(0).scrollWidth;
            var secondsPerPixel = 0.02;
            var animationDuration = Math.floor(scrollWidth * secondsPerPixel).toString() + 's';
            $images.css('width', scrollWidth);
            $images.css('animation-duration', animationDuration);
            $images.addClass('active');    
        }
    }

    function addIeClassToBody () {
        if( isInternetExplorer() ) {
            $('body').addClass('internet-explorer');
        }
    }

    function initAccordion() {
        var accordionLevels = [
            'accordion',
            'subaccordion'
        ];

        var urlHash = '#' + location.hash.slice(1);

        function toggle($body, $teaser, $arrow) {
            $body.slideToggle();
            $teaser.slideToggle();
            $arrow.toggleClass('active');
        }

        accordionLevels.forEach(function(level) {
            var $container = $(`.js-${level}-container`);
            $.each($container, function() {
                var $this = $(this);
                var $trigger = $this.find(`.js-${level}-trigger`);
                var $arrow = $this.find(`.js-${level}-arrow`);
                var $body = $this.find(`.js-${level}-body`);
                var $teaser = $this.find(`.js-${level}-teaser`);

                var triggerHash = $trigger.attr('href');

                if (triggerHash === urlHash) {
                    setTimeout(function() {
                        var offset = $(braid.header).height() + 16;
                        $htmlBody.animate(
                            { scrollTop: $this.offset().top - offset },
                            '500',
                            'swing'
                        );    
                    }, 500);

                    toggle($body, $teaser, $arrow);
                }
        
                $trigger.click(function() {
                    toggle($body, $teaser, $arrow);
                });
            });
        });
    }

    function handleInquiryForm() {
        var $inquiryForms = $('.js-inquiry-form');
        $.each($inquiryForms, function() {
            var $this = $(this);
            var $button = $this.find('.js-inquiry-form-button');
            var $formContainer = $this.find('.js-inquiry-form-container');
            $button.click(function() {
                $formContainer.slideToggle();
            });
        });
    }

    function handleConnectForm() {
        var $connectForms = $('.js-connect-form');
        $.each($connectForms, function() {
            var $this = $(this);
            var $buttons = $this.find('.js-connect-form-button');
            var $formContainers = $this.find('.js-connect-form-container');

            $.each($buttons, function(index) {
                var $this = $(this);
                $this.click(function() {
                    $formContainers.removeClass('active');
                    $($formContainers[index]).addClass('active');
                    $buttons.removeClass('active');
                    $this.addClass('active');
                });
            });
        });
    }

    function initHeadlineSlider() {
        var $headlineSlider = $('.js-headline-slider');
        $headlineSlider.slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 8000,
            pauseOnFocus: false,
            pauseOnHover: false
        });
    }

    function handleMobileMenuAccordion() {
        var $subheadings = $('.site-header .header-row .menu-header-main-container .menu>.menu-item>.sub-menu>.menu-item');
        $.each($subheadings, function() {
            var $this = $(this);
            var $trigger = $this.children('a');
            var $list = $this.children('.sub-menu');
            $trigger.click(function(e) {
                e.preventDefault();
                $this.toggleClass('active');
                $list.slideToggle();
            });
        });
    }

    function handleHeaderScroll() {
        var threshold = -100;
        function setHeaderScroll() {
            var distanceFromTop = -braid.content.getBoundingClientRect().top;
            if (distanceFromTop > threshold) {
                braid.header.classList.add("scrolled");
            } else {
                braid.header.classList.remove("scrolled");
            }
        }

        setHeaderScroll();
        window.onscroll = throttle(setHeaderScroll, 100);
    }

    function handleGetEmail() {
        $('.js-get-email').click(function() {
            var $this = $(this);
            var $cogIcon = $this.find('.js-cog-icon');
            $cogIcon.addClass('active');
            var postId = $this.data('post-id');
            $.get('/wp-json/tra/v1/email', { postId: postId })
                .done(function(email) {
                    if(email.length) {
                        window.location.href = 'mailto:' + email;
                    }
                })
                .always(function() {
                    $cogIcon.removeClass('active');
                });
        });
    }

    // ----
    // public methods and variables
    // ----
    ns.init = function() {
        toggleNavMenu();
        smoothScroll();
        initLazyLoad();
        contentAccordion();
        handleLoginMenuToggle();
        addIeClassToBody();
        initAccordion();
        handleInquiryForm();
        handleConnectForm();
        initHeadlineSlider();
        handleMobileMenuAccordion();
        handleHeaderScroll();
        handleGetEmail();
    };

    ns.windowLoadInit = function() {
        initSlider();
    };



}(braidStarter = braidStarter || {}, jQuery(window), jQuery));







jQuery(document).ready(function($) {
    braidStarter.init();
});

jQuery(window).load(function() {
    braidStarter.windowLoadInit();
});